import FeaturesManager from 'utils/features/FeaturesManager';

// Register the feature flag for Risk Pool demo data
FeaturesManager.registerFeature({
  id: 'risk_pool_demo_data',
  name: 'Risk Pool Demo Data',
  description: 'Enable demo data for Risk Pool dashboard (mocked calculations). When disabled, fetches real data from API.',
  enabled: false,
  maxEnv: 'prod',
});

/**
 * Hook to check if Risk Pool demo data mode is enabled.
 * When enabled, all Risk Pool data sources will return mock/demo data instead of API data.
 * This is used for marketing demos and testing purposes.
 *
 * @returns {boolean} True if demo data should be used, false if real API data should be used
 */
export const useRiskPoolDemoData = (): boolean => {
  return FeaturesManager.getInstance().isFeatureEnabled('risk_pool_demo_data');
};
